module.exports = __webpack_public_path__ + "static/media/rzetelna_firma.2b2c0430.png";